import { render, staticRenderFns } from "./SeminarList.vue?vue&type=template&id=fe1ff4be&scoped=true&"
import script from "./SeminarList.vue?vue&type=script&lang=js&"
export * from "./SeminarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1ff4be",
  null
  
)

export default component.exports